<script>
  import AppPageHeader from '../../../components/main/PageHeader'
  import EmptyList from '../../../components/list/EmptyList'

  import * as restfulService from '../../../services/restfulService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  import {isEmpty} from 'lodash'

  export default {
    mixins: [helpers],
    components: {AppPageHeader, EmptyList},
    mounted () {
      this.buscarNotificacoes()
    },
    data () {
      return {
        notificacoes: [],
        mostrarDatepickerDataInicial: false,
        mostrarDatepickerDataFinal: false,
        dataInicial: null,
        dataFinal: null,
        dataInicialFormatada: null,
        dataFinalFormatada: null,
        titulo: '',
        mensagem: '',
        enviadaEm: true,
        visualizadaEm: true,
        abertaEm: true,
        paginaAtual: 1,
        totalPaginas: 1,
        mostrarModalNotificacao: false,
        notificacao: {
          notificacao: {}
        }
      }
    },
    watch: {
      dataInicial () {
        this.dataInicialFormatada = this.dateFormat(this.dataInicial, 'br')
      },
      dataFinal () {
        this.dataFinalFormatada = this.dateFormat(this.dataFinal, 'br')
      }
    },
    computed: {
      listaVazia: function () {
        return this.notificacoes.length === 0
      }
    },
    methods: {
      buscarNotificacoes () {
        bus.$emit('show-loader')
        this.notificacoes.splice(0)
        let data = {
          pagina: this.paginaAtual,
          enviadaEm: this.enviadaEm,
          visualizadaEm: this.visualizadaEm,
          abertaEm: this.abertaEm
        }
        if (!isEmpty(this.titulo)) {
          data.titulo = this.titulo
        }
        if (!isEmpty(this.mensagem)) {
          data.mensagem = this.mensagem
        }
        if (!isEmpty(this.dataFinal) && !isEmpty(this.dataFinal)) {
          data.data_inicial = this.dataFinal
          data.data_final = this.dataFinal
        }
        restfulService.post('usuario', 'notificacoes', null, data)
          .then((response) => {
            if (response.data.length) {
              this.notificacoes = [...this.notificacoes, ...response.data]
            } else {
              this.paginaAtual = 1
            }
            this.totalPaginas = Math.ceil(response.total / response.per_page)
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      mostrarNotificacao (item) {
        this.notificacao = item
        this.mostrarModalNotificacao = true
      },
      limparFiltros () {
        this.titulo = ''
        this.mensagem = ''
        this.dataInicial = null
        this.dataFinal = null
        this.dataInicialFormatada = null
        this.dataFinalFormatada = null
        this.enviadaEm = true
        this.visualizadaEm = true
        this.abertaEm = true
        this.buscarNotificacoes()
      },
      trocarPagina (value) {
        if (value !== this.paginaAtual) {
          this.paginaAtual = value
          this.buscarNotificacoes()
        }
      }
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="box">
            <v-container fluid grid-list-md>
                <h4>Filtrar notificações</h4>
                <v-layout row wrap>
                    <v-flex sm8 xs12>
                        <v-layout row wrap>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="titulo"
                                              label="Título"/>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-text-field v-model="mensagem"
                                              label="Mensagem"/>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm6 xs12>
                                <v-menu ref="datepickerDataInicial"
                                        :close-on-content-click="false"
                                        v-model="mostrarDatepickerDataInicial"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px">
                                    <v-text-field slot="activator"
                                                  v-model="dataInicialFormatada"
                                                  label="Data Inicial"
                                                  persistent-hint
                                                  prepend-icon="event"
                                                  @blur="dataInicial = dateFormat(dataInicialFormatada, 'en')"/>
                                    <v-date-picker v-model="dataInicial"
                                                   @input="mostrarDatepickerDataInicial = false"
                                                   locale="pt-br"/>
                                </v-menu>
                            </v-flex>
                            <v-flex sm6 xs12>
                                <v-menu ref="datepickerDataFinal"
                                        :close-on-content-click="false"
                                        v-model="mostrarDatepickerDataFinal"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px">
                                    <v-text-field slot="activator"
                                                  v-model="dataFinalFormatada"
                                                  label="Data Final"
                                                  persistent-hint
                                                  prepend-icon="event"
                                                  @blur="dataFinal = dateFormat(dataFinalFormatada, 'en')"/>
                                    <v-date-picker v-model="dataFinal"
                                                   @input="mostrarDatepickerDataFinal = false"
                                                   locale="pt-br"/>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex sm4 xs12>
                        <strong>Status da Notificação</strong><br>
                        <v-switch v-model="enviadaEm"
                                  label="Enviada"
                                  color="orange"
                                  hide-details/>
                        <v-switch v-model="visualizadaEm"
                                  label="Visualizada"
                                  color="orange"
                                  hide-details/>
                        <v-switch v-model="abertaEm"
                                  label="Aberta"
                                  color="orange"
                                  hide-details/>
                    </v-flex>
                </v-layout>
                <v-btn color="primary" @click="buscarNotificacoes" title="Pesquisar Notificações">
                    <i class="fas fa-search"></i>
                    <span class="pl-1">Pesquisar</span>
                </v-btn>
                <v-btn @click="limparFiltros" title="Limpar filtros">
                    <i class="fas fa-eraser"></i>
                    <span class="pl-1">Limpar</span>
                </v-btn>
            </v-container>
            <v-divider/>
            <empty-list v-if="listaVazia"
                        title="Você ainda não possui notificações"
                        description="Assim que alguma nota, avaliação for registrada ou algum evento for criado você irá receber as notificações aqui"/>
            <v-container fluid grid-list-md v-if="!listaVazia">
                <h4>Lista de Notificações</h4>
                <v-list two-line>
                    <template v-for="(item, index) in notificacoes">
                        <v-list-tile :key="item.title"
                                     @click="mostrarNotificacao(item)"
                                     ripple>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.notificacao.titulo }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ item.notificacao.mensagem }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title class="minhas-notificacoes-status-mobile">
                                    <span><strong>Enviada em:</strong> {{item.enviada_em | dateTimeEnToBr}}</span>
                                    <span v-if="item.visualizada_em"> | <strong>Visualizada em:</strong> {{item.visualizada_em | dateTimeEnToBr}}</span>
                                    <span v-if="item.aberta_em"> | <strong>Aberta em:</strong> {{item.aberta_em | dateTimeEnToBr}}</span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action class="minhas-notificacoes-status-desktop">
                                <v-list-tile-action-text>
                                    <strong>Enviada em:</strong> {{item.enviada_em | dateTimeEnToBr}}
                                </v-list-tile-action-text>
                                <v-list-tile-action-text v-if="item.visualizada_em">
                                    <strong>Visualizada em:</strong> {{item.visualizada_em | dateTimeEnToBr}}
                                </v-list-tile-action-text>
                                <v-list-tile-action-text v-if="item.aberta_em">
                                    <strong>Aberta em:</strong> {{item.aberta_em | dateTimeEnToBr}}
                                </v-list-tile-action-text>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider v-if="index + 1 < notificacoes.length"
                                   :key="index"/>
                    </template>
                </v-list>
                <v-pagination v-model="paginaAtual"
                              :length="totalPaginas"
                              :total-visible="10"
                              @input="trocarPagina"/>
            </v-container>
        </div>
        <v-dialog v-model="mostrarModalNotificacao">
            <v-card class="modal-notificacao">
                <h3>{{notificacao.notificacao.titulo}}</h3>
                <div class="modal-notificacao-texto">{{notificacao.notificacao.mensagem}}</div>
                <div class="modal-notificacao-data">
                    Enviada em: <span>{{notificacao.enviada_em | dateTimeEnToBr}}</span>
                </div>
                <div class="modal-notificacao-data" v-if="notificacao.visualizada_em">
                    Visualizada em: <span>{{notificacao.visualizada_em | dateTimeEnToBr}}</span>
                </div>
                <div class="modal-notificacao-data" v-if="notificacao.aberta_em">
                    Aberta em: <span>{{notificacao.aberta_em | dateTimeEnToBr}}</span>
                </div>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModalNotificacao = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style lang="scss">
    .minhas-notificacoes-status-mobile {
        display: none;
    }

    @media all and (max-width: 768px) {
        .minhas-notificacoes-status-mobile {
            display: block;
            font-size: 12px;
        }
        .minhas-notificacoes-status-desktop {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// MinhasNotificacoes.vue?55e50d83